import jsonp from './jsonp';

const getQrCode = async url => {
    let num = 0;
    let callbackName = `getQrCode_${num}`;

    while (window[callbackName]) {
        num++;
        callbackName = `getQrCode_${num}`;
    }

    return await jsonp(`//qrcode.ifeng.com/qrcode.php?url=${url}?_share=weixin`, {
        jsonpCallback: callbackName,
        cache: false,
    });
};

export default getQrCode;
